import React, { useState } from 'react';
import { Button, Icon, Input, H1 } from '@tviklax/ui-components';
import {
    PageContainer,
    Header,
    Breadcrumb,
    ContentContainer,
    TabsContainer,
    TabButton,
    FormContainer,
    SectionTitle,
    SectionDescription,
    FormGroup,
    FullWidthGroup,
    Actions
} from './BusinessSettings.styles';
import { FileUpload } from './FileUpload';
import { TextArea } from './TextArea';
import { AccessControl } from './AccessControl';

const TABS = [
    'Company details',
    'SMTP',
    'Payment gateway',
    'Email templates',
    'SMS templates',
    'Invoices',
    'Taxes',
    'Shipping'
];

export const BusinessSettings: React.FC = () => {
    const [activeTab, setActiveTab] = useState('Company details');

    return (
        <PageContainer>
            <Header>
                <H1 style={{ margin: '0' }}>Business Settings</H1>
                <Breadcrumb>
                    <Icon name="LayoutDashboard" size={16} />
                    <span>/</span>
                    <span>Settings</span>
                    <span>/</span>
                    <span>Business settings</span>
                </Breadcrumb>
            </Header>

            <ContentContainer>
                <TabsContainer>
                    {[...TABS, 'Access Control'].map(tab => (
                        <TabButton
                            key={tab}
                            $active={activeTab === tab}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </TabButton>
                    ))}
                </TabsContainer>

                {activeTab === 'Company details' && (
                    <FormContainer
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <SectionTitle>Company Details</SectionTitle>
                        <SectionDescription>
                            Update your company information here. This will be displayed on invoices and other communications.
                        </SectionDescription>

                        <FormGroup>
                            <Input label="Company Name" placeholder="Enter company name" />
                            <Input label="Company Email" placeholder="Enter company email" type="email" validateEmail helperText="We’ll send billing notices here" />
                        </FormGroup>

                        <FormGroup>
                            <Input
                                label="Phone Number"
                                placeholder="Enter phone number"
                                startAdornment={
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', paddingRight: '8px', borderRight: '1px solid #e2e8f0' }}>
                                        <Icon name="Globe" size={16} />
                                        <span style={{ fontSize: '0.875rem', color: '#64748b' }}>+1</span>
                                    </div>
                                }
                            />
                            <div /> {/* Spacer for grid */}
                        </FormGroup>

                        <FullWidthGroup>
                            <TextArea label="Address" placeholder="Enter company address" />
                        </FullWidthGroup>

                        <FullWidthGroup>
                            <SectionTitle style={{ fontSize: '0.875rem', marginBottom: '8px' }}>Company Logo</SectionTitle>
                            <FileUpload label="Company Logo" />
                        </FullWidthGroup>

                        <Actions>
                            <Button variant="muted">Reset</Button>
                            <Button>Save Changes</Button>
                        </Actions>
                    </FormContainer>
                )}

                {activeTab === 'Access Control' && (
                    <FormContainer
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <AccessControl />
                    </FormContainer>
                )}

                {activeTab !== 'Company details' && activeTab !== 'Access Control' && (
                    <FormContainer
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
                            <Icon name="Settings" size={48} color="#cbd5e1" style={{ marginBottom: '16px' }} />
                            <h3>{activeTab} Settings</h3>
                            <p>This section is under development.</p>
                        </div>
                    </FormContainer>
                )}
            </ContentContainer>
        </PageContainer>
    );
};
